import React from "react";
import {
  Truck,
  Package,
  MapPin,
  BarChart,
  Clock,
  Warehouse,
  Route,
  FileText,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Fleet Tracking",
    description: "Real-time GPS tracking and fleet visibility solutions",
    icon: MapPin,
  },
  {
    title: "Route Optimization",
    description: "AI-powered route planning for delivery efficiency",
    icon: Route,
  },
  {
    title: "Warehouse Management",
    description: "Build WMS solutions for inventory and operations",
    icon: Warehouse,
  },
  {
    title: "Last-Mile Delivery",
    description: "Develop delivery apps with proof of delivery and tracking",
    icon: Truck,
  },
  {
    title: "Supply Chain Visibility",
    description: "End-to-end visibility across the supply chain",
    icon: Package,
  },
  {
    title: "Scheduling & Dispatch",
    description: "Automated dispatch and driver scheduling systems",
    icon: Clock,
  },
  {
    title: "Analytics & KPIs",
    description: "Performance dashboards for logistics optimization",
    icon: BarChart,
  },
  {
    title: "Documentation",
    description: "Digital freight documentation and compliance management",
    icon: FileText,
  },
];

const STATS = [
  { value: "1M+", label: "Deliveries/Month" },
  { value: "500+", label: "Fleet Clients" },
  { value: "30%", label: "Route Efficiency" },
  { value: "Real-time", label: "Tracking" },
];

const LogisticsIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="logistics"
      industryTitle="Logistics"
      industrySubtitle="& Supply Chain"
      heroDescription="Optimizing supply chain operations with intelligent logistics solutions for fleet management, warehouse operations, and last-mile delivery that reduce costs and improve service."
      themeColor="#6366f1"
      themeColorLight="#818cf8"
      themeGradient="linear-gradient(135deg, #312e81 0%, #4338ca 50%, #6366f1 100%)"
      HeroIcon={Truck}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default LogisticsIndustryPage;
